<script>
import { mapGetters } from 'vuex'
import { productsMethods } from '@state/helpers'
import MultiSelectWarehouse from '@components/retina/MultiSelectWarehouse'
import QrSearch from './qrSearch'
import SerialSearch from '@components/retina/products/serialSearch'

export default {
  name: 'ProductsTable',
  components: {
    MultiSelectWarehouse,
    QrSearch,
    SerialSearch,
  },
  props: {
    enabledWarehouseMultiselect: {
      type: Boolean,
      default: true,
      required: false
    },
    serialSearchInput: {
      type: Boolean,
      default: true,
      required: false
    },
    enableQrSearch: {
      type: Boolean,
      default: true,
      required: false,
      },
    drfprovider: {
      type: Function,
      required: false,
      default: () => null,
    },
    provider: {
      type: Function,
      required: false,
      default: () => null,
    },
    tableheaders: {
      type: [Array, Object],
      required: true,
    },
    perpage: {
      type: Number,
      required: false,
      default: 10,
    },
    pageoptions: {
      type: Array,
      required: false,
      default() {
        let pages = []
        let perpage = this.perpage
        for (let index = 1; index <= 3; index++) {
          pages.push(index * perpage)
        }
        return pages
      },
    },
    sortby: {
      type: String,
      required: false,
      default: '',
    },
    sortdesc: {
      type: NaN,
      required: false,
      default: null,
    },
    emptyText: {
      type: String,
      default: 'Sin registros para mostrar',
    },
    emptyFilteredText: {
      type: String,
      default: 'No se encontraron registros',
    },
    responsiveTable: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      isBusy: false,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      lastFilter: '',
      // --- Filter Serial ---
      serial_input: null,
      searching: false,
      select: false,
    }
  },
  computed: {
    ...mapGetters({
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
      qr_serial: 'retina/products/qr_serial',
    }),
  },
  methods: {
    ...productsMethods,
    onFiltered(filteredItems) {
      if (this.filter !== this.lastFilter) {
        this.currentPage = 1
        this.lastFilter = this.filter
      }
    },
    setFilterList() {
      let filters_list = []

      if (Boolean(this.warehouse_selected)) {
        filters_list.push('warehouse=' + this.warehouse_selected.id)
        if (Boolean(this.ubication_selected))
          filters_list.push('ubication=' + this.ubication_selected.id)
      }
      if(this.qr_serial) {
        filters_list.push('serial=' + this.qr_serial)
      }

      return filters_list
    },
    baseProvider(ctx) {
      ctx.filterset = ''
      let filters_list = this.setFilterList()
      if (filters_list.length) ctx.filterset = filters_list.join('&')

      let promise = this.drfprovider(ctx)
      if (promise) {
        return promise.then((data) => {
          this.totalRows = data.count
          return data.results
        })
      } else {
        return this.provider(ctx)
      }
    },
    refresh() {
      this.$refs.table.refresh()
    },
  },
  watch: {
    warehouse_selected() {
      this.$refs.table.refresh()
    },
    ubication_selected() {
      this.$refs.table.refresh()
    },
    qr_serial() {
      this.$refs.table.refresh()
    }    
  },
}
</script>
<template>
  <b-card no-body>
    <div class="p-1 p-md-2"><!-- card-body -->
      <b-row >
        <b-col lg="6" md="12">
          <b-form-group label="Búsqueda" label-cols-xl="2">
            <b-input-group>
              <b-form-input
                ref="filter"
                v-model="filter"
                debounce="600"
                type="text"
                placeholder="Nombre o Referencia"
              ></b-form-input>
              <b-input-group-append>
                <b-button v-if="filter" @click="filter = ''" variant="light" v-b-tooltip.hover="{ variant: 'light', title:'Limpiar búsqueda'}">
                  <i class="fas fa-times"></i>
                </b-button>
                <!-- <QrSearch v-if="enableQrSearch" v-b-tooltip.hover="{ variant: 'info', title:'Buscar por QR'}" /> -->
                <slot name="button-content">
                </slot>
              </b-input-group-append>
              
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="serialSearchInput">
        <b-col lg="6" md="12">
          <b-form-group label="Serial" label-cols-xl="2">
          <SerialSearch :showResults="false"/>
          </b-form-group>
          </b-col>
      </b-row>
      
      <b-row v-if="enabledWarehouseMultiselect" >
        <b-col md="12" lg="12">
          <MultiSelectWarehouse :label_cols_xl="4" :content_cols_xl="8" />
        </b-col>
        <!-- <b-col v-if="enableQrSearch" md="12" lg="6" class="pt-lg-4 pt-xl-0">
          <QrSearch />
        </b-col> -->
      </b-row>

      <b-row>
          <b-col sm="12" md="6" class="pt-2 my-1 text-muted">
            {{ $t('datatable.showing') }} <span style="color: #F28C02">{{ !totalRows ? 0 : ((currentPage - 1) * perpage) + 1 }} - {{ !totalRows ? 0 : currentPage * perpage >= totalRows ? totalRows : currentPage * perpage }} {{ $t('datatable.of') }} {{ totalRows || 0 }} </span> 
          </b-col>
      </b-row>

      <b-row>
        <b-col class="p-0">
          <b-table
            ref="table"
            class="m-0"
            striped
            hover
            small
            :items="baseProvider"
            :fields="tableheaders"
            :per-page="perpage"
            :current-page="currentPage"
            :busy="isBusy"
            :filter="filter"
            :sort-by.sync="sortby"
            :sort-desc.sync="sortdesc"
            :responsive="responsiveTable"
            show-empty
            :empty-text="emptyText"
            :empty-filtered-text="emptyFilteredText"
            @filtered="onFiltered"
          >
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
              <slot :name="slot" v-bind="scope"/>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-corp my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> {{ $t('datatable.loading') }}...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" md="5">
          <b-form-group
              :label="$t('datatable.recordsperpage')"
              label-align-sm="left"
              label-size="sm"
              label-cols-xs="8"
              label-cols-sm="8"
              label-cols-md="8"
              label-cols-lg="5"
              content-cols-xs="4"
              content-cols-sm="4"
              content-cols-md="4"
              content-cols-lg="4"
              label-for="perPageSelect"
              label-class="font-weight-normal"
              class="mb-0 mt-1"
              >
            <b-form-select
              v-model="perpage"
              size="sm"
              :options="pageoptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col offset-md="4" sm="7" md="3" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perpage"
            align="right"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div><!-- card-body -->
  </b-card>
</template>
<style lang="scss">
  .products_table .multiselect__option {
    white-space: normal;
    font-weight: 300;
    font-size: 14px;
  }
</style>